// extracted by mini-css-extract-plugin
export default {"photoContainer":"property_photo_photoContainer__hrghq","picture":"property_photo_picture__DqZib"};